function TabsComponent(args, callbacks = {}) {
    this.args = {
        container:	args.container ? args.container : '.js-tabs-resorts',
        navigation:	args.navigation ? args.navigation : '.Tabs-nav li',
        item:       args.item ? args.item : '.Tabs-item'
    };
    args = this.args;

    if (typeof args.container === 'string') {
        args.container = document.querySelector(args.container);
    }

    if (typeof args.navigation === 'string' && args.container) {
        args.navigation = args.container.querySelectorAll(args.navigation);
    }

    if (typeof args.item === 'string' && args.container) {
        args.item = args.container.querySelectorAll(args.item);
    }

    if (!args.container || !args.navigation.length || !args.item.length) {
        return;
    }

    // определяем параметры по умолчанию для аргументов функции
    const { onChange } = callbacks;
    const $navigation = args.navigation;
    const $item = args.item;
    if (!$navigation) {
        return false;
    }

    /**
     * Кликл по меню навигации
     */
    $navigation.forEach($nav => {
        $nav.addEventListener('click', e => {
            e.preventDefault();
    
            const $target = e.target;
            let index = 0;

            $navigation.forEach(function($nav, i) {
                if ($nav === $target.parentElement || $nav === $target) {
                    index = i;
                }
            });
    
            // убираем active у всех
            $navigation.forEach($element => {
                $element.classList.remove('is-active');
            });

            $item.forEach($element => {
                $element.classList.remove('is-active');
            });
    
            // отмечаем выбранное
            if ($navigation[index]) {
                $navigation[index].classList.add('is-active');
            }
            if ($item[index]) {
                $item[index].classList.add('is-active');
            }
    
            // callback
            if (typeof onChange === 'function') {
                onChange(index, $item[index]);
            }
        });
    });

    // скроллим до таба, при инициализации страницы
    $navigation.forEach(function($nav) {
        if ($nav.classList.contains('is-active')) {
            let offset = $nav.getBoundingClientRect().left + $nav.offsetWidth;
            
            if (offset >= window.innerWidth) {
                $nav.parentElement.scrollLeft += (offset - window.innerWidth) + 10;
            }
        }
    });
}

// возвращаем класс
export default TabsComponent;
